import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";

import { getStyles } from "src/styles/theme";
import ViewForm from "src/components/common/ViewForm";
import defaultStyles from "./styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation } from "react-query";
import { deleteComponentView } from "src/utils/api/dashboard";
import { useDeletionState } from "src/hook/deletion-state";
import { SuccessModal } from "src/components/common/modal";
import { useState } from "react";
import ViewImages from "src/components/common/ViewImage";

export type DashBoardTable = {
  topHeader: string[];
  data: any;
};
const topHeader = [
  "S. No.",
  "Botanical Name",
  "Common Name",
  "No. Of Seedling",
  "Average Height(m)",
  "Survival(%)",
  "Observations",
];
export function PlantationView({ data, images, submitted }: any) {
  const styles = getStyles(defaultStyles);

  const { setComponentDeletionState } = useDeletionState();
  const { mutate, isLoading, isError } = useMutation({
    mutationFn: () => deleteComponentView(data?.plantationMonitoring?.id),
    onSuccess: () => {
      console.log("Plantation detail deleted successfully.");
      setComponentDeletionState((prev) => !prev);
    },
    onError: (error) => {
      console.error("Error deleting fencing detail:", error);
    },
  });

  const tableData = data?.species.map((item) => ({
    botanicalName: item.species?.botanicalName,
    commonName: item.species?.commonName,
    numberOfSeedlings: item.species?.numberOfSeedlings,
    avgHeight: item.avgHeight,
    avgSurvival: item.avgSurvival,
    remark: item.remark,
  }));
  const tableLabel = {
    // Year: data?.plantationMonitoring.year,
    // Monitoring: data?.plantationMonitoring?.month,
    // "Month And Year": data?.plantationMonitoring?.yearMonth,
    "Average Height (m)": data?.plantationMonitoring?.avgHeight,
    "Average Survival (%)": data?.plantationMonitoring?.avgSurvival,
  };

  const [openModal, setOpenModal] = useState({
    open: false,
    heading: "Delete This Component",
    subheading: "Are you sure?",
    description: "",
    btnText: "Confirm",
    type: "Alert",
  });
  const handleResponseModal = () => {
    mutate();
    handleModalClose();
  };
  const handleModalClose = () => {
    setOpenModal({ ...openModal, open: false });
  };

  return (
    <Box {...styles("viewWrapper")}>
      <Box>
        {Object.entries(tableLabel).map((item) => (
          <ViewForm label={item[0]} value={item[1]} />
        ))}
      </Box>
      <TableContainer
        component={Paper}
        sx={{ height: "fit-content", mt: "20px" }}
      >
        <Table sx={{ minWidth: 600 }} aria-label="simple table">
          <TableHead {...styles("header")}>
            <TableRow sx={{ backgroundColor: "custom.greyish.3" }}>
              {topHeader.map((item, index) => (
                <TableCell align="center" {...styles("cell")} key={index}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData &&
              tableData.length > 0 &&
              tableData.map((item, index) => {
                if (!item) return null;
                return (
                  <TableRow key={index}>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "30px" })}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "100px" })}
                    >
                      {item.botanicalName}
                    </TableCell>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "100px" })}
                    >
                      {item.commonName}
                    </TableCell>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "100px" })}
                    >
                      {item.numberOfSeedlings}
                    </TableCell>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "100px" })}
                    >
                      {item.avgHeight}
                    </TableCell>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "100px" })}
                    >
                      {item.avgSurvival}
                    </TableCell>
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "100px" })}
                    >
                      {item.remark}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box>
        <Box sx={{ mt: "20px", fontSize: "17px", fontWeight: "600" }}>
          Overall Observations nn Sapling Survival:
        </Box>
        <Box sx={{ fontSize: "17px", fontWeight: "400" }}>
          {data?.plantationMonitoring.remark || ""}
        </Box>
      </Box>
      <Box {...styles("imageContainer")}>
        {images?.map((item) => (
          <ViewImages fileUrl={item.url} />
        ))}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        {!submitted && (
          <Button
            endIcon={<DeleteIcon />}
            onClick={() => setOpenModal((prev) => ({ ...prev, open: true }))}
            disabled={isLoading}
          >
            {isLoading ? "Deleting..." : "Delete"}
          </Button>
        )}
      </Box>
      {isError && <Box sx={{ color: "red" }}>Failed to delete. Try again.</Box>}
      <SuccessModal
        open={openModal.open}
        heading={openModal.heading}
        subheading={openModal.subheading}
        description={openModal.description}
        btnText={openModal.btnText}
        type={openModal.type}
        onClick={() => handleResponseModal()}
        handleModalClose={() => handleModalClose()}
      />
    </Box>
  );
}
